import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { YouTubePlayer } from '@angular/youtube-player';

@Component({
    selector: 'app-youtube-video',
    templateUrl: './youtube-video.component.html',
    styleUrls: ['./youtube-video.component.scss'],
    imports: [YouTubePlayer],
})
export class YoutubeVideoComponent {
  @Input() public videoId = '';

  @Input() public studentLifeCardSize: boolean = false;

  @Output() private videoPlaying = new EventEmitter<boolean>();

  @ViewChild('player') private readonly thePlayer!: YouTubePlayer;

  public pauseVideo(): void {
    this.thePlayer.pauseVideo();
  }

  public videoStateChanged(event: YT.OnStateChangeEvent): void {
    // event.target.pauseVideo();
    /* (UNSTARTED = -1),
    (ENDED = 0),
    (PLAYING = 1),
    (PAUSED = 2),
    (BUFFERING = 3),
    (CUED = 5); */

    if (event.target.getPlayerState() !== YT.PlayerState.PAUSED)
      if (event.target.getPlayerState() === YT.PlayerState.ENDED) {
        this.videoPlaying.emit(false);
      } else {
        this.videoPlaying.emit(true);
      }
  }
}
